<template>
  <div>
    <b-overlay :show="isLoadingData" rounded="sm">
      <b-navbar toggleable="lg" type="dark" variant="light">
        <b-navbar-brand href="#" class="text-dark">
          <strong>Documents</strong>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                class="mr-2"
                variant="outline-warning"
                size="sm"
                @click="showAddDocumentModal = !showAddDocumentModal"
              >
                <font-awesome-icon icon="plus" />
              </b-button>
              <b-form-group
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                label-for="filterInput"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <b-table-simple borderless>
        <b-thead>
          <b-tr>
            <b-th>Document</b-th>
            <b-th>type</b-th>
            <b-th>Uploaded Date</b-th>
            <b-th>Link</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(data,index) in documentsData" :key="index">
            <b-td>{{ data.title }}</b-td>
            <b-td>{{ data.type }}</b-td>
            <b-td>{{ data.uploaded_at }}</b-td>
            <b-td class="text-primary" @click="viewDocumentCall(data)" style="cursor: pointer;">
              <u>View</u>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <b-row>
        <b-col cols="2">
          <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
        </b-col>
        <b-col>
          <b-pagination
            class="float-right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            first-text="First"
            prev-text="Prev"
            next-text="Next"
            last-text="Last"
            aria-controls="my-table"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-overlay>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Add Document"
      v-model="showAddDocumentModal"
      scrollable
      size="lg"
    >
      <b-row>
        <b-col cols="12">
          <label>Upload Supporting Document :</label>
          <!-- @vdropzone-success="vsuccess" -->
          <vue-dropzone
            ref="myVueDropzone"
            id="dropzone"
            :options="dropzoneOptions"
            :useCustomSlot="true"
            v-on:vdropzone-sending="sendingEvent"
          >
            <div class="dropzone-custom-content">
              <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
              <div class="subtitle">...or click to select a file from your computer</div>
            </div>
          </vue-dropzone>
        </b-col>
        <b-col class="mt-3" cols="12">
          <b-form-group label="Enter Display Name:">
            <b-form-input v-model="displayName" type="search" placeholder="Type to Search"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <b-button variant="outline-danger" @click="showAddDocumentModal = false">Close</b-button>
        <!-- @click="checkValidation()" -->
        <b-button variant="outline-success">Upload</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import uid from "uid";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueDropzone from "../../Dropzone/VueDropzone";
import { HTTP } from "../../../utils/HTTP";
export default {
  name: "DocumentsTabComponent",
  data() {
    return {
      displayName: null,
      filter: null,
      pageOptions: [5, 10, 25, 50, 100],
      perPage: 5,
      currentPage: 1,
      totalRows: 0,
      isLoadingData: false,
      documentsData: [],
      showAddDocumentModal: false,
      dropzoneOptions: {
        url: process.env.VUE_APP_API_URL + "thirdparty/uploaddocument",
        thumbnailWidth: 150,
        maxFilesize: 25,
        addRemoveLinks: true,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
        }
      }
    };
  },
  components: {
    VueDropzone
  },
  computed: {
    rows() {
      return this.totalRows;
    }
  },
  mounted() {
    this.getTpManageDocuments();
  },
  methods: {
    async getTpManageDocuments() {
      this.documentsData = [];
      let formData = {
        thirdPartyId: this.$route.params.thirdPartyId,
        companyId: this.$route.params.companyId
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.isLoadingData = true;
        let result = await HTTP(
          "post",
          "thirdparty/managedocuments",
          formData,
          {
            Authorization: token
          }
        );
        if (result && result.data.status == 1 && result.status == 200) {
          this.documentsData = result.data.response;
          this.isLoadingData = false;
          this.$store.state.documentsTabLazyLoad = false;
        } else {
          this.documentsData = [];
          this.isLoadingData = false;
          this.$store.state.documentsTabLazyLoad = false;
        }
      } catch (error) {
        this.isLoadingData = false;
      }
    },
    viewDocumentCall(data) {
      let urlAddress = process.env.VUE_APP_BASE_URL + "/" + data.url;
      window.open(urlAddress);
    },
    // vsuccess(file, response) {
    //   let uploadedFile = {};
    //   if (response && response.url) {
    //     uploadedFile = {
    //       fileId: uid(),
    //       filename: file.name,
    //       caption: { english: this.slideCaption },
    //       text: { english: this.slideText },
    //       size: file.size,
    //       type: file.type,
    //       url: response.url
    //     };
    //     this.files.push(uploadedFile);
    //     this.$refs.myVueDropzone.removeFile(file);
    //   }
    // },
    sendingEvent(file, xhr, formData) {
      formData.append("thirdPartyId", this.$route.params.thirdPartyId);
      formData.append("companyId", this.$route.params.companyId);
      formData.append("displayName", this.displayName);
      formData.append("targetDirectory", "targetDirectory");
      formData.append("originalFile", "originalFile");
    }
  }
};
</script>